module.exports = "/assets/aca9063a9835963c2fca3eeddd237733.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AF.png
// module id = 1193
// module chunks = 0